import styled from 'styled-components';

export const StyledCollapse = styled.div`
  margin-bottom: ${({ theme }): string => theme.spacing_unit_x2};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const CollapseTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const CollapseBody = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }): 'block' | 'none' => (isOpen ? 'block' : 'none')};
  overflow: hidden;
  transition: max-height 0.2s ease-out;
  padding: ${({ theme }): string => theme.spacing_unit_x2} 0;
`;
